export const initialState = {
  weddingTitle: "",
  isTitleError: false,
  titleErrorText: "",
  isSubmitting: false,
};

export function weddingFormReducer(state, action) {
  switch (action.type) {
    case "SET_TITLE":
      return {
        ...state,
        weddingTitle: action.payload,
        isTitleError: false,
        titleErrorText: "",
      };
    case "SET_ERROR":
      return {
        ...state,
        isTitleError: true,
        titleErrorText: action.payload,
      };
    case "SET_SUBMITTING":
      return {
        ...state,
        isSubmitting: action.payload,
      };
    case "RESET_FORM":
      return initialState;
    default:
      return state;
  }
}
